import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types.esm.js';

var _container;
var base = {
  boxShadow: 'cosmos',
  borderRadius: '0',
  width: '100%',
  minWidth: '400px'
};
var centerPosition = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(max(-50%,-50vh))'
};
var smallDialog = {
  maxWidth: '578px'
};
var mediumDialog = {
  maxWidth: '701px'
};
var largeDialog = {
  maxWidth: '820px'
};
var layout = {
  header: {
    color: 'white',
    backgroundColor: 'black'
  },
  display: {
    variant: 'text.display'
  },
  body: {
    variant: 'styles.root'
  },
  footer: {
    color: 'white',
    backgroundColor: 'black'
  },
  container: (_container = {}, _defineProperty(_container, THEME_UI_DEFAULT_KEY, {
    maxWidth: '1600px'
  }), _defineProperty(_container, 'high-res-desktop', {
    maxWidth: '1950px'
  }), _defineProperty(_container, 'full-width', {
    maxWidth: '100%'
  }), _defineProperty(_container, 'input-form', {
    maxWidth: '610px'
  }), _container),
  modal: {
    cosmos: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, base), centerPosition), smallDialog), {}, {
      medium: _objectSpread2(_objectSpread2(_objectSpread2({}, base), centerPosition), mediumDialog),
      large: _objectSpread2(_objectSpread2(_objectSpread2({}, base), centerPosition), largeDialog)
    })
  }
};

export { layout };
//# sourceMappingURL=layout.esm.js.map
